import styled from 'styled-components';

import ModalCancelOrder from 'components/ModalCancelOrder/container';

export default styled(ModalCancelOrder)``;
